import navigation from '@/components/Navigation.vue';
import bar        from '@/components/Bar.vue';

export default {

    name: 'Index',
    components: {navigation, bar}

};
